<template>
  <div class="single-offer">
    <div class="alert alert-light rounded" v-if="!is_answer">
      {{ $t("message.contracts.offer_from") }}:
      <strong>{{ offer_.name }}</strong>
    </div>
    <div class="alert alert-success rounded" v-else>
      {{ $t("message.contracts.update_fields_you_need") }}
    </div>
    <div v-if="!offer_.no_changes">
      <div class="row">
        <div class="col-6">
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="offer_.discount_percents"
              :placeholder="
                $t('message.contracts.invoice_products_DiscountPercentage')
              "
              autocomplete="off"
              style="cursor: auto"
              id="discount_percents"
            />
            <label
              for="discount_percents"
              class="form-label-group-label shorter"
              >{{
                $t("message.contracts.invoice_products_DiscountPercentage")
              }}</label
            >
          </span>
        </div>
        <div class="col-6">
          <span
            :class="[
              'bmd-form-group mb-2 mt-2 d-block form-label-group',
              payment_focused ? 'focused' : '',
            ]"
          >
            <v-select-popup
              type="payment_type"
              :placeholder="$t('message.contracts.payment_conditions')"
              v-model="offer_.payment_type"
            />

            <!-- <v-select id="contract_payment_type" :options="payment_types" label="display_text" :class="['form-control', offer_.payment_type.value!==''?'vs--selected':'']" @search="fetchPaymentType"  v-model="offer_.payment_type" :placeholder="$t('message.contracts.payment_conditions')" @focus="paymentFocused" @blur="paymentBlurred"></v-select>
	                    <label for="contract_payment_type" class="form-label-group-label shorter">{{$t('message.contracts.payment_conditions')}}</label> -->
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="offer_.discount_amount"
              :placeholder="$t('message.contracts.invoice_products_Discount')"
              autocomplete="off"
              style="cursor: auto"
              id="discount_amount"
            />
            <label
              for="discount_amount"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.invoice_products_Discount") }}</label
            >
          </span>
        </div>
        <div class="col-6">
          <span
            :class="[
              'bmd-form-group mb-2 mt-2 d-block form-label-group',
              delivery_focused ? 'focused' : '',
            ]"
          >
            <v-select-popup
              type="delivery_term"
              :placeholder="$t('message.contracts.conditions')"
              v-model="offer_.delivery_term"
            />

            <!-- <v-select id="contract_delivery_terms" :options="delivery_terms" label="display_text" :class="['form-control', offer_.delivery_term.value!==''?'vs--selected':'']" @search="fetchDeliveryTerms"  v-model="offer_.delivery_term" :placeholder="$t('message.contracts.conditions')" @focus="deliveryFocused" @blur="deliveryBlurred"></v-select>
	                    <label for="contract_delivery_terms" class="form-label-group-label shorter">{{$t('message.contracts.conditions')}}</label> -->
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <input
              type="text"
              class="form-control"
              v-model="offer_.shipping_cost"
              :placeholder="$t('message.contracts.shipping_cost')"
              autocomplete="off"
              style="cursor: auto"
              id="shipping_cost"
            />
            <label for="shipping_cost" class="form-label-group-label shorter">{{
              $t("message.contracts.shipping_cost")
            }}</label>
          </span>
        </div>
        <div class="col-12">
          <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group']">
            <!-- <b-form-datepicker :locale="locale" v-model="offer_.contract_date" :placeholder="$t('message.contracts.contract_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="contract_date"></b-form-datepicker>
	                    <label for="contract_date" class="form-label-group-label shorter topped">{{$t('message.contracts.contract_date')}}</label> -->

            <datepicker
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="offer_.contract_date = ' '"
              @blur="
                offer_.contract_date == ' '
                  ? (offer_.contract_date = '')
                  : (offer_.contract_date = offer_.contract_date)
              "
              inputClass="form-control"
              :disabled="is_field_readonly"
              v-model="offer_.contract_date"
              :placeholder="$t('message.contracts.contract_date')"
              :inputAttr="{ id: 'contract_date' }"
            />
            <label
              for="contract_date"
              class="form-label-group-label shorter"
              :class="
                offer_.contract_date != '' && offer_.contract_date != null
                  ? 'topped'
                  : ''
              "
              >{{ $t("message.contracts.contract_date") }}</label
            >
          </span>
        </div>
      </div>
      <span :class="['bmd-form-group mb-2 d-block form-label-group ']">
        <textarea
          class="form-control"
          v-model="offer_.offer"
          :placeholder="$t('message.contracts.offer')"
          autocomplete="off"
          style="cursor: auto"
          id="single_offer_offer"
        ></textarea>
        <label
          for="single_offer_offer"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.offer") }}</label
        >
      </span>

      <span
        :class="['bmd-form-group mb-2 d-block form-label-group ']"
        v-if="is_answer"
      >
        <textarea
          class="form-control"
          v-model="offer_.answer"
          :placeholder="$t('message.contracts.offer_answer')"
          autocomplete="off"
          style="cursor: auto"
          id="single_offer_answe"
        ></textarea>
        <label
          for="single_offer_answer"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.offer_answer") }}</label
        >
      </span>
      <div
        class="d-block files-block"
        v-if="
          typeof offer_.files !== 'undefined' &&
          offer_.files != null &&
          offer_.files.length > 0
        "
      >
        <label>{{ $t("message.contracts.attachements") }}</label>
        <div class="file-o" v-for="(file, index) in offer_.files" :key="index">
          <div class="row">
            <div class="col-12">
              <a target="_blank" :href="'/Picture/GetFile/' + file.id">
                <i class="fas fa-arrow-down"></i> {{ file.name }}</a
              >
            </div>
            <!--<div class="col-1">
							<button class="btn btn-sm btn-link text-danger" @click="deleteFile(file, index)"><i class="fa fa-trash"></i></button>
						</div>-->
          </div>
        </div>
        <!--<div v-for="(file, index) in files_att" class="row">
					<div class="col-11">
						<input type="file" @change="attachFile($event, index)" class="form-control">
					</div>
					<div class="col-1">
						<button class="btn btn-sm btn-link text-danger" @click="removeFile(index)">&times;</button>
					</div>
				</div>
				<div>
					<button class="btn btn-sm btn-outline-success" @click="addAttachement">{{$t('message.contracts.add_attachement')}}</button>
					<br>
					<small><i>{{$t('message.contracts.add_attachement_info')}}</i></small>
				</div>-->
      </div>
    </div>
    <!--<span :class="['bmd-form-group mb-2 d-block form-label-group required']">
			<input type="text" readonly class="form-control" v-model="offer_.contract_search_subj_country" :placeholder="$t('message.contracts.contragents_search_country')" autocomplete="off" style="cursor: auto;" id="single_offer_country">
			<label for="single_offer_country" class="form-label-group-label shorter">{{$t('message.contracts.contragents_search_country')}}</label>
		</span>
		<span :class="['bmd-form-group mb-2 d-block form-label-group required']">
			<input type="text" readonly class="form-control" v-model="offer_.contract_search_subj_name" :placeholder="$t('message.contracts.contragents_search_name')" autocomplete="off" style="cursor: auto;" id="single_offer_name">
			<label for="single_offer_name" class="form-label-group-label shorter">{{$t('message.contracts.contragents_search_name')}}</label>
		</span>
		<span :class="['bmd-form-group mb-2 d-block form-label-group required']">
			<textarea class="form-control" v-model="offer_.attis_contrfact_offer_text" :placeholder="$t('message.contracts.offer')" autocomplete="off" style="cursor: auto;" id="single_offer_offer"></textarea>-->
    <!--<label for="single_offer_country" class="form-label-group-label shorter">{{$t('message.contracts.offer')}}</label>-->
    <!--</span>
		<span :class="['bmd-form-group mb-2 d-block form-label-group required']">
			<textarea class="form-control" v-model="offer_.attis_contract_offer_goods" :placeholder="$t('message.contracts.products_description')" autocomplete="off" style="cursor: auto;" id="single_offer_products"></textarea>-->
    <!--<label for="single_offer_country" class="form-label-group-label shorter">{{$t('message.contracts.offer')}}</label>-->
    <!--</span>
		<span :class="['bmd-form-group mb-2 d-block']" v-if="typeof offer_.doc_guid!=='undefined' && offer_.doc_guid!==''">
			<label for="document_file" class="form-label-group-label shorter pb-0 pr-2">{{$t('message.contracts.offer_file')}}</label>
			<a target="_blank" :href="'/document/getfile/'+offer_.doc_guid">{{offer_.doc_name}}</a>
		</span>-->
    <!--<span  :class="['bmd-form-group mb-2 d-block form-label-group']">
			<b-form-datepicker :locale="locale" v-model="offer_.valid_date" :placeholder="$t('message.contracts.offer_valid_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="single_offer_date"></b-form-datepicker>
		</span>-->
    <!--<span :class="['bmd-form-group mb-2 d-block form-label-group required']">
			<textarea class="form-control" v-model="offer_.changes" :placeholder="$t('message.contracts.offer_changes')" autocomplete="off" style="cursor: auto;" id="single_offer_changes"></textarea>-->
    <!--<label for="single_offer_country" class="form-label-group-label shorter">{{$t('message.contracts.offer')}}</label>-->
    <!--</span>-->
  </div>
</template>
<script>
export default {
  props: {
    offer: Object,
    is_answer: Boolean,
  },
  data() {
    return {
      payment_types: [],
      delivery_terms: [],
      files_att: [],
      offer_: {
        name: "",
        country: {
          value: "",
        },
        offer: "",
        products_description: "",
        changes: "",
        files: [],

        payment_type: { value: "", display_text: "" },
        delivery_term: { value: "", display_text: "" },
        discount_percents: "",
        discount_amount: "",

        no_changes: false,
        answer: "",
      },
      countries: [],
      country_focused: false,
      payment_focused: false,
      delivery_focused: false,
    };
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  mounted() {
    this.fetchCountries("");
    this.fetchCompany();
    this.fetchPaymentType("");
    this.fetchDeliveryTerms("");
    this.offer_ = this.offer;
    console.log("tikrinu offers");
    console.log(this.offer_);
  },
  methods: {
    attachFile(event, index) {
      if (typeof event.target.files[0] !== "undefined")
        this.files_att[index] = event.target.files[0];
    },
    removeFile(index) {
      this.files_att.splice(index, 1);
    },
    addAttachement() {
      this.files_att.push("");
    },
    deleteFile(file, index) {
      axios
        .get(window.base + "/Picture/DeleteFile/" + file.id)
        .then((response) => {
          this.offer_.files.splice(index, 1);
        });
    },
    deliveryFocused() {
      this.delivery_focused = true;
    },
    deliveryBlurred() {
      this.delivery_focused = false;
      // this.validateField('company_status')
    },
    fetchDeliveryTerms(search, loading) {
      this.getLibrary("delivery_term", search, 100);
    },
    fetchPaymentType(search, loading) {
      this.getLibrary("payment_type", search, 100);
    },
    fetchCompany() {
      // axios.get(window.base + '/document/getfirmfull').then(response=>{
      // 	this.current_company = response.data
      // 	if(typeof response.data.organizations !== 'undefined' && typeof response.data.organizations.org_name!=='undefined')
      // 		this.offer_.name = response.data.organizations.org_name
      // 	if(typeof response.data.organizations !== 'undefined' && typeof response.data.organizations.org_code!=='undefined')
      // 		this.offer_.bin = response.data.organizations.org_code
      // 	this.offer_.country = response.data.org_residency
      // })
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 100);
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          console.log("tikrinu type.length");
          console.log(type.length);
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") {
              if (item.value == this.offer.payment_type)
                this.offer_.payment_type = item;
              this.$data[var_name].push(item);
            }
          });
        });
    },
    paymentFocused() {
      this.payment_focused = true;
    },
    paymentBlurred() {
      this.payment_focused = false;
    },
  },
};
</script>
<style>
.alert-light {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
</style>
